import Vue from "vue";
import Axios from "axios";

const axios = Axios.create({
  validateStatus: (status) => {
    if (status == 401) {
      window.localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return true;
  },
});

axios.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("token");
  if (token) {
    config.headers = {
      Authorization: token ? `Bearer ${token}` : "",
    };
  }
  return config;
});

Vue.prototype.$axios = axios;
